import React from 'react';
import PropTypes from 'prop-types';

import { ProductsGridLoading } from './ProductsGridLoading';
import { ProductsGridContent } from './ProductsGridContent';
import { NumberedPagination } from '../common/pagination/NumberedPagination';

export const ProductsGrid = ({ className, isLoading, data, onPrevious, onNext, onPage }) => {
    if (isLoading) {
        return <ProductsGridLoading className={className} />;
    }

    return (
        <div className={className}>
            <ProductsGridContent products={data.records} />
            <NumberedPagination
                className="align-items-center"
                onPrevious={onPrevious}
                onNext={onNext}
                onPage={onPage}
                data={data}
            />
        </div>
    );
};

ProductsGrid.propTypes = {
    className: PropTypes.string,
    onPrevious: PropTypes.func,
    onNext: PropTypes.func,
    isLoading: PropTypes.bool,
    data: PropTypes.object
};

ProductsGrid.defaultProps = {
    className: '',
    isLoading: true,
    data: null
};
